// extracted by mini-css-extract-plugin
export var measureBox = "_ad-0";